var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pic-uploader-component"
  }, [_c("el-upload", {
    ref: "upload",
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      disabled: _vm.disabled,
      action: _vm.path + "/p/file/upload",
      headers: {
        Authorization: _vm.token
      },
      "show-file-list": _vm.complaints == true ? true : false,
      "on-success": _vm.handleUploadSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "on-remove": _vm.handleRemove
    }
  }, [!_vm.complaints ? _c("div", [_vm.resourcesVal ? _c("img", {
    staticClass: "pic avatar",
    attrs: {
      src: _vm.resourcesVal
    }
  }) : _c("i", {
    staticClass: "el-icon-plus pic-uploader-icon"
  })]) : _vm._e(), _vm.complaints && !_vm.value ? _c("div", {
    staticClass: "complaintsBtn"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      icon: "el-icon-top"
    }
  }, [_vm._v("上传附件")]), _c("div", {
    staticClass: "el-upload__tip",
    attrs: {
      slot: "tip"
    },
    slot: "tip"
  }, [_vm._v("支持格式.png .jpg .jpeg，不超过5M")])], 1) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };